export const salaryAmountTypeOptions = [
    {text: 'Annually', value: 'ANNUALLY'},
    {text: 'Monthly', value: 'MONTHLY'},
    {text: 'Weekly', value: 'WEEKLY'},
    {text: 'Daily', value: 'DAILY'},
    {text: 'Hourly', value: 'HOURLY'},
];

export const taxCodeOptions = [
    {text: 'S', value: 'S'},
    {text: 'S1', value: 'S1'},
    {text: 'S2', value: 'S2'},
    {text: 'S3', value: 'S3'},
    {text: 'S4', value: 'S4'},
    {text: 'M', value: 'M'},
    {text: 'M1', value: 'M1'},
    {text: 'M2', value: 'M2'},
    {text: 'M3', value: 'M3'},
    {text: 'M4', value: 'M4'},
    {text: 'Z', value: 'Z'},
];

export const peraTypeOptions = [
    {text: 'United Investment Trust Funds', value: 'UNITED_INVESTMENT_TRUST_FUNDS'},
    {text: 'Mutual Funds', value: 'MUTUAL_FUNDS'},
    {
        text: 'Stocks From PSE-Listed Companies',
        value: 'STOCKS_FROM_PSE_LISTED_COMPANIES',
    },
    {text: 'Government Securities', value: 'GOVERNMENT_SECURITIES'},
    {text: 'Insurance Pension Products', value: 'INSURANCE_PENSION_PRODUCTS'},
    {text: 'Annuity Contracts', value: 'ANNUITY_CONTRACTS'},
    {
        text: 'Other Investment Products Authorized For PERA Purposes',
        value: 'OTHER',
    },
];

